import { Dispatch } from 'redux';
import { ThunkAction } from 'redux-thunk';
import * as actionTypes from './types';
import { getTree } from '../../service/tree.service';

type AppThunk<ReturnType = void> = ThunkAction<ReturnType, any, unknown, any>;

/**
 * Loads the caller's reachable organisation/entity/workspace tree. Dispatched from the
 * auth fetchUser thunk, independent of any default workspace: a user can have a tree
 * and no default workspace.
 */
export const fetchTree = (): AppThunk => async (dispatch: Dispatch) => {
  dispatch({ type: actionTypes.FETCH_TREE_LOADING });
  try {
    const tree = await getTree();
    dispatch({ type: actionTypes.FETCH_TREE_SUCCESS, payload: { tree } });
  } catch (error) {
    console.error('Failed to fetch tree', error);
    dispatch({ type: actionTypes.FETCH_TREE_FAILED });
  }
};
